import { render } from "./ImageDialog.vue?vue&type=template&id=0288533a"
import script from "./ImageDialog.vue?vue&type=script&lang=js"
export * from "./ImageDialog.vue?vue&type=script&lang=js"

import "./ImageDialog.vue?vue&type=style&index=0&id=0288533a&lang=scss"
script.render = render

export default script